import React from 'react';
import './WhyNow.css';

const WhyNow = () => {
  return (
    <section className="why-now-section">
      <div className="why-now-container">
        <div className="questionmark-bg">
          <img src="/images/questionmark.svg" alt="" />
        </div>
        <div className="why-now-intro">
          <div className="why-now-line"></div>
          <span className="why-now-badge">WHY NOW</span>
        </div>
        <p className="why-now-description-one">
          Global demand is surging for intelligent, explainable, and compliant AI — especially in high-stakes sectors like Law, Health, FinTech, RegTech and ESG & Energy.
          Cognitva is leading the way.

        </p>
      </div>
    </section>
  );
};

export default WhyNow; 